

const inkCollectorBar = {
  template: require('./collector-bar.template.html'),
  controller: function(Session) {
    this.session = Session;
  }
};

angular
  .module('inkfinder')
  .component('inkCollectorBar', inkCollectorBar);



// WEBPACK FOOTER //
// ./components/collector/collector-bar/collector-bar.component.js